export default "__VITE_ASSET__3c279321__"